export function hasParagraphTag(input: string): boolean {
  // Use a case-insensitive regex to match <p> or </p> tags
  const pTagRegex = /<\/?p\s*.*?>/i;

  // Test if the input string contains a paragraph tag
  return pTagRegex.test(input);
}
